import React, { useState } from "react";
import { Modal, Button } from "antd";
import winDownload from "../../assets/downloadHelp/windows/download.png";
import winRun from "../../assets/downloadHelp/windows/run.png";
import winApp from "../../assets/downloadHelp/windows/app.png";
import winJoin from "../../assets/downloadHelp/windows/join.png";
import winRunMerge from "../../assets/downloadHelp/windows/run_merge.png";

import macDownload from "../../assets/downloadHelp/mac/download.png";
import macRun from "../../assets/downloadHelp/mac/run.png";
import macApp from "../../assets/downloadHelp/mac/app.png";
import drag from "../../assets/downloadHelp/mac/drag.png";
import macJoin from "../../assets/downloadHelp/mac/join.png";
import macRunMerge from "../../assets/downloadHelp/mac/run_merge.png";

import { HelpCircle } from "lucide-react";

const MonitorDownloadHelp = ({ modalType, onClose }) => {
  const [current, setCurrent] = useState(0);

  const steps =
    modalType === "Windows"
      ? [
          {
            title: "Download the Monitor Tool",
            description:
              "Click the link shown in the image to download the monitor tool to your device.",
            image: winDownload,
          },
          {
            title: "Launch the Monitor Tool",
            description:
              "Once the download is complete, double-click the file to start the tool.",
            image: winRun,
          },
          {
            title: "Verify Security Prompt",
            description:
              "When the security warning appears, click on “More info” to review the app details, then choose “Run anyway” to launch the app.",
            image: winRunMerge,
          },
          {
            title: "Keep the Tool Running",
            description:
              "The tool will launch and display its interface. Make sure it stays open during the entire interview.",
            image: winApp,
          },
          {
            title: "Join the Interview",
            description:
              "Once the tool is running, a modal will appear. If everything is set up correctly, you can proceed to join the interview.",
            image: winJoin,
          },
        ]
      : [
          {
            title: "Download the Monitor Tool",
            description:
              "Click the link shown in the image to download the monitor tool to your device.",
            image: macDownload,
          },
          {
            title: "Open the Monitor Tool",
            description:
              "After the download completes, double-click the file to open the tool.",
            image: macRun,
          },
          {
            title: "Move to Applications",
            description:
              "Drag the downloaded file into the Applications folder to install the tool.",
            image: drag,
          },
          {
            title: "Launch from Applications",
            description:
              "Open the tool from your Applications folder and confirm the security prompt by selecting “Open.”",
            image: macRunMerge,
          },
          {
            title: "Keep the Tool Running",
            description:
              "The tool will launch and display its interface. Make sure it stays open during the entire interview.",
            image: macApp,
          },
          {
            title: "Join the Interview",
            description:
              "Once the tool is running, a modal will appear. If everything is set up correctly, you can proceed to join the interview.",
            image: macJoin,
          },
        ];

  const next = () => setCurrent((prev) => Math.min(prev + 1, steps.length - 1));
  const prev = () => setCurrent((prev) => Math.max(prev - 1, 0));

  const isLast = current === steps.length - 1;

  return (
    <Modal
      open={Boolean(modalType)}
      footer={null}
      centered
      width={540}
      onCancel={onClose}
      title=<div className="flex gap-2 items-center">
        <HelpCircle size={21} />{" "}
        {modalType === "Windows" ? (
          <div className="text-lg">How to run for Windows</div>
        ) : (
          <div className="text-lg">How to run for Mac</div>
        )}
      </div>
    >
      <div className="mt-[.85rem] flex flex-col items-center text-center gap-y-1">
        {/* Image */}
        <div className="w-full h-[14rem] bg-gray-300 rounded-lg shadow-md flex items-center justify-center overflow-hidden">
          <img
            src={steps[current].image}
            alt="step"
            className="object-contain h-full rounded-lg"
          />
        </div>

        {/* Step Label */}
        <div className="mt-2 text-sm text-gray-500">Step {current + 1}</div>

        {/* Title */}
        <div className="text-[1.05rem] font-semibold">
          {steps[current].title}
        </div>

        {/* Description */}
        <div className="text-gray-500 text-sm px-4">
          {steps[current].description}
        </div>

        {/* Dots */}
        <div className="flex space-x-2 mt-2">
          {steps.map((_, index) => (
            <div
              key={index}
              className={`w-2 h-2 rounded-full ${
                index === current ? "bg-blue-500" : "bg-gray-300"
              }`}
            />
          ))}
        </div>

        {/* Buttons */}
        <div className="flex flex-col md:flex-row w-full gap-2 pt-4">
          <button
            className={`${
              current === 0 ? "btn-grey-disable" : "btn-white"
            } px-4 py-2 w-full md:w-1/2`}
            disabled={current === 0}
            onClick={prev}
          >
            Previous
          </button>

          {!isLast ? (
            <button
              className="btn-blue px-4 py-2 w-full md:w-1/2"
              onClick={next}
            >
              Next
            </button>
          ) : (
            <button
              className="btn-blue px-4 py-2 w-full md:w-1/2"
              onClick={onClose}
            >
              Close
            </button>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default MonitorDownloadHelp;
